module.exports = __webpack_public_path__ + "static/media/button_menublack.8be0a728.svg";